import React from "react";
import CardClient from "./CardClient";

const TableClients = () => {

    return (
        <div className="container-table-clients">
            <div className="container-title-client-data">
                <h3 className="table-title">NOMBRE Y APELLIDO</h3>
                <h3 className="table-title">CÉDULA</h3>
                <h3 className="table-title">CELULAR</h3>
                <h3 className="table-title">CANT. BOLETAS</h3>
            </div>
                <CardClient />
                <CardClient />
                <CardClient />
                <CardClient />
                <CardClient />
                <CardClient />
                <CardClient />
        </div>
    )
};

export default TableClients;